import { atom } from "recoil"

export const showsSideNavigationState = atom({
  key: "showsSideNavigationState",
  default: false,
})
